import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import * as requests from '../../infrastructure/requests';
import * as formatters from '../formatters';

import LinearProgress from '@material-ui/core/LinearProgress';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import mixpanel, { Events as MPEvents } from '../../infrastructure/mixpanel';
import Error from '../components/Error';
import PageContainer from '../container/PageContainer';
import OptimizerV1Result from './OptimizerV1Result';
import PlaceProfilerV1Results from './PlaceProfilerV1Results';
import StopVisitMatchingDetails from './StopVisitMatchingDetails';

const styles = {
    oneLine: {
        display: 'flex'
    },
    cardContent: {
        maxWidth: '100%',
        padding: 0
    },
    card: {
        padding: 0
    }
};

class Execution extends Component {
  state = {
      loading: false,
      log: undefined,
      execution: undefined,
      error: undefined
  };

  componentDidMount() {
      this.load();
      mixpanel.track(MPEvents.CONSOLE_ACTIVITY_VIEW_DETAIL);
  }

  async load() {
      try {
          const { id } = this.props;
          this.setState({ loading: true, execution: undefined, log: undefined });
          const log = await requests.getLog(id);
          let execution;
          if (
              log.request === 'optimizerV1' ||
        log.request === 'optimizerV2' ||
        log.request === 'stopVisitMatchingV1' ||
        log.request === 'placesProfilerV1'
          ) {
              execution = await requests.getExecution(id);
          }
          this.setState({
              log,
              execution,
              loading: false
          });
      } catch (error) {
          this.setState({
              error: error.message,
              loading: false
          });
      }
  }

  handleStartDateOffset = startDateOffset => {
      this.setState({ startDateOffset }, this.loadLogStatistics);
  };

  handleChange = name => event => {
      this.setState({ [name]: event.target.checked });
      mixpanel.track(MPEvents.CONSOLE_ACTIVITY_DETAILS_SHOW_DETAILS, {
          key_id: this.props.id
      });
  };

  render() {
      const { log, execution, loading, error } = this.state;
      const { payload, response } = execution || {};
      const { classes } = this.props;
      return (
          <React.Fragment>
              {loading && <LinearProgress />}
              {error && <Error message={error} />}
              {log && (
                  <PageContainer className={classes.card}>
                      <CardContent className={classes.cardContent}>
                          <Typography color="textSecondary">{log.id}</Typography>
                          <Typography variant="h5" className={classes.oneLine}>
                              {formatters.status(log.status)}
                              {log.request}
                          </Typography>
                          {log.status === 'failed' && <Error message={log.message} />}
                          <Typography color="textPrimary">
                              <b>Started:</b> {new Date(log.created).toLocaleString()} <br />
                              <b>Duration:</b> {formatters.durationMillis(log.duration)}
                          </Typography>
                          {log && log.request === 'stopVisitMatchingV1' && payload && (
                              <StopVisitMatchingDetails
                                  problem={payload}
                                  solution={response}
                              />
                          )}
                          {log &&
                (log.request === 'optimizerV1' ||
                  log.request === 'optimizerV2') &&
                payload &&
                response && (
                              <OptimizerV1Result
                                  problem={payload}
                                  solution={response}
                                  details={true}
                              />
                          )}
                          {log &&
                log.request === 'placesProfilerV1' &&
                payload &&
                response && (
                              <PlaceProfilerV1Results
                                  problem={payload}
                                  solution={response}
                              />
                          )}
                      </CardContent>
                  </PageContainer>
              )}
          </React.Fragment>
      );
  }
}

export default withStyles(styles)(Execution);
